import React from "react";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { Why } from "../components/landing/Why";
import { Features } from "../components/landing/Features";
import { CommunityWatch } from "../components/landing/CommunityWatch";
import { HowItWorks } from "../components/landing/HowItWorks";
import { Privacy } from "../components/landing/Privacy";
import { Testimonials } from "../components/landing/Testimonials";
import { FAQ } from "../components/landing/FAQ";
import { BetaCTA } from "../components/landing/BetaCTA";
import { Download } from "../components/landing/Download";
import { Footer } from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#FBFBF9]">
      <Navbar />
      <main>
        <Hero />
        <Why />
        <Features />
        <CommunityWatch />
        <HowItWorks />
        <Privacy />
        <Testimonials />
        <FAQ />
        <BetaCTA />
        <Download />
      </main>
      <Footer />
    </div>
  );
}
